import _ from 'lodash';

export function hasManageBilling(user) {
  return user.permissions && user.permissions.manageBilling;
}

export function hasManageUsers(user) {
  return user.permissions && user.permissions.manageUsers;
}

export function hasCreateDashboards(user) {
  return user.permissions && user.permissions.createDashboards;
}

export function hasDashboardAccess(user, dashboardId, ability) {
  let hasAccess = false;
  if (user.permissions && user.permissions.manageDashboards) {
    return true;
  }

  if (user.permissions && user.permissions.dashboards) {
    const dashboardPermissions = _.find(user.permissions.dashboards, {
      dashboardId
    });
    if (dashboardPermissions) {
      return !!dashboardPermissions[ability];
    }
  }

  return hasAccess;
}

